import {
  FaAngleLeft,
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaPhoneAlt,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { FacebookShareButton, TwitterShareButton } from "react-share";
import avatar from "../images/avatar.jpg";
export default function SakrebuloInternal({
  presscenterList,
  image,
  full_name,
  position,
  description,
  email,
  mobile,
  language,
}) {
  const navigate = useNavigate();

  return (
    <div>
      <div className="sakrebulo-landing sakrebulo1">
        <div className="landing-container">
          <div className="image-wrapper">
            <img src={image ? image : avatar} alt={full_name} />
            <div className="sakrebulo-landing-near-image">
              <h3>{full_name}</h3>
              <span>{position}</span>
              <div className="">
                <div className="socials">
                  <a href="" target="blank">
                    <FaFacebookF />
                  </a>
                  <a href="" target="blank">
                    <FaInstagram />
                  </a>
                  <a href="" target="blank">
                    <FaYoutube />
                  </a>
                </div>
                <div>
                  <a href={`mailto:${email}`}>
                    <FaEnvelope />
                    {email}
                  </a>
                  <a href={`tel:${mobile}`}>
                    <FaPhoneAlt />
                    {mobile}
                  </a>
                </div>
              </div>
              {/* <div className='languages'>
              <h3>ენები: {member.geo.language} </h3> <span></span>
            </div> */}
            </div>
          </div>
          <div className="sakrebulo-landing-paragraphs">
            <span
              dangerouslySetInnerHTML={{
                __html: description,
              }}
            ></span>
          </div>
        </div>
        <div className="share">
          <span className="back" onClick={() => navigate(-1)}>
            <div>
              <FaAngleLeft />
            </div>{" "}
            {language === 1 ? " უკან დაბრუნება " : "BACK"}
          </span>
          <span>
            {language === 1 ? "გააზიარე:" : "SHARE:"}
            <FacebookShareButton url={window.location.href}>
              <FaFacebookF />
            </FacebookShareButton>
            <TwitterShareButton url={window.location.href}>
              <FaTwitter />
            </TwitterShareButton>
          </span>
        </div>
      </div>
      <div className="presscenter-info">{presscenterList}</div>
    </div>
  );
}
